<template>
    <div class="ui-page">
        <ui-page-header title="Questionário modelo"
            subtitle="Perguntas padrão do questionário de fiscalização (ex.: produtor rural). Cada caso começa com elas e pode ser ajustado na aba Questionário.">
            <v-btn v-if="$allowed('rma.template')" color="primary" depressed @click="openEdit(null)"><v-icon left small>mdi-plus</v-icon>Nova pergunta</v-btn>
        </ui-page-header>

        <section class="ui-card" style="padding: 0;">
            <div v-if="loading" class="ui-small ui-muted pa-4">Carregando...</div>
            <rma-question-list v-else :questions="questions" :busy="busy" empty-text="Nenhuma pergunta no modelo. Use &quot;Nova pergunta&quot; para começar."
                @edit="openEdit" @remove="remove" @reorder="reorder" />
        </section>

        <rma-question-dialog v-model="edit.open" :question="edit.question" :answer-types="answerTypes" :saving="busy"
            description="Vale para os casos que ainda vão começar o questionário; casos que já têm perguntas podem trazer as novas pelo botão &quot;Trazer do modelo&quot;."
            @save="save" />
    </div>
</template>

<script>
import axios from "axios";
import RmaQuestionDialog from "@/components/rma/RmaQuestionDialog.vue";
import RmaQuestionList from "@/components/rma/RmaQuestionList.vue";
import { notifyError, notifySuccess } from "@/components/rma/rma.util";

// Fiscalizacao mensal > Questionario modelo.
export default {
    name: "RmaQuestionTemplate",

    components: { RmaQuestionDialog, RmaQuestionList },

    data: () => ({ loading: false, busy: false, questions: [], answerTypes: [], edit: { open: false, question: null } }),

    created() {
        this.load();
    },

    methods: {
        apply(content) {
            this.questions = content.questions || [];
            this.answerTypes = content.answer_types || [];
        },

        async load() {
            this.loading = true;
            try {
                this.apply((await axios.get("/api/admin/rma/questions")).data.content);
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.loading = false;
            }
        },

        openEdit(question) {
            this.edit = { open: true, question };
        },

        async save(payload) {
            this.busy = true;
            try {
                const result = payload.id
                    ? await axios.put(`/api/admin/rma/questions/${payload.id}`, payload)
                    : await axios.post("/api/admin/rma/questions", payload);
                this.apply(result.data.content);
                this.edit.open = false;
                notifySuccess(this, "Pergunta salva no modelo.");
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.busy = false;
            }
        },

        async remove(question) {
            const confirmed = await this.$dialog.confirm({
                title: "Excluir pergunta",
                text: `"${question.text}" sai do modelo. Casos que já têm a pergunta continuam com ela. Confirma?`,
                actions: { false: "Cancelar", true: { text: "Excluir", color: "error" } },
            });
            if (!confirmed) return;
            this.busy = true;
            try {
                this.apply((await axios.delete(`/api/admin/rma/questions/${question.id}`)).data.content);
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.busy = false;
            }
        },

        async reorder(ids) {
            this.busy = true;
            try {
                this.apply((await axios.post("/api/admin/rma/questions/reorder", { ids })).data.content);
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.busy = false;
            }
        },
    },
};
</script>
